import React, { useEffect, useState } from "react";
import styles from "./report.module.css";
import SlideBox from "../../common/SlideBox/SlideBox";
import { FETCH_ALL_MERCHANT_VALIDATIONS } from "../../utils/constant";
import useApiServices from "../../utils/useApiServices";
import { useSelector } from "react-redux";
import { ReportsRegistry } from "../../Privillages/ReportsRegistry";

const Report = () => {
  const [flag, setFlag] = useState(false);
  const [report, setReport] = useState("");
  const [dropDownData, setDropDownData] = useState([]);
  const { apiCallFnforGet } = useApiServices();

  const { catalog = {}, allowed = [] } = useSelector(
    (state) => state.userPrivileges
  );
  const userPrivilegeIdSet = new Set(allowed);

  const toggleRightBar = (type) => {
    if (type) {
      setReport(type);
    }
    setFlag(!flag);
  };

  const getMerchantData = async () => {
    try {
      const response = await apiCallFnforGet(FETCH_ALL_MERCHANT_VALIDATIONS);
      if (response?.statusCode === 200) {
        setDropDownData(response?.data);
      } else {
        setDropDownData([]);
      }
    } catch (error) {
      setDropDownData([]);
    }
  };

  useEffect(() => {
    getMerchantData();
  }, []);

  const onToggle = (key) => {
    setReport(key);
    setFlag((v) => !v);
  };

  const reportsConfig = catalog?.Reports || {};
  const selectedReport = ReportsRegistry.find((t) => t?.key === report);
  const commonProps = {
    type: report,
    dropDownData,
    toggleRightBar: onToggle,
  };

  return (
    <div className="content-body">
      <div className="container-fluid ">
        <div class="card card-inverse card-primary text-center">
          <div class="card-body pb-1">
            <SlideBox flag={flag} toggleRightBar={onToggle}>
              {selectedReport?.component &&
                React.createElement(selectedReport.component, commonProps)
              }
            </SlideBox>

            <div className="row text-center text-lg-start">
              {ReportsRegistry?.map((item, idx) => {
                const subId = reportsConfig?.idMap?.[item?.requiredSub];
                if (!subId || !userPrivilegeIdSet?.has(subId)) return null;
                return (
                  <div
                    key={idx}
                    className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["report-icon"]}`}
                  >
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      onClick={() => toggleRightBar(item?.key)}
                    >
                      <img
                        class="img-fluid img-thumbnail"
                        src={item?.icon || "/images/default-icon.png"}
                        alt={item?.title}
                      />
                      <h5 className="mt-2 text-primary text-md text-sm">
                        {item?.label || "NA"}
                      </h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;